export default "__VITE_ASSET__a5nY1TwC__"